export const PortalDefaultTitle = 'Inter.link Portal'
export const ServiceWizardContractTerm = 12

export const LEGAL_LINKS = {
  TERMS_OF_SERVICE:
    'https://inter.link/wp-content/uploads/2024/10/07032024-3-Interlink-MSA-.pdf', // we use this link for the registration and service provisioning
  TERMS_OF_SERVICE_SLA: 'https://inter.link/sla', // this is used for the footer.
  PRIVACY_POLICY: '/legal/privacy',
  IMPRINT: 'https://inter.link/imprint/',
  NETWORK_MAP: '/map',
} as const

export const NAVIGATION_LINKS = {
  KNOWLEDGE_BASE: 'https://inter.link/knowledgebase',
  LOOKING_GLASS: 'https://lg.as5405.net',
  BGP_COMMUNITIES: 'https://inter.link/knowledgebase/bgp-communities/',
  PEERINGDB_AS5405: 'https://www.peeringdb.com/asn/5405',
  BGP_TOOLS_AS5405: 'https://bgp.tools/as/5405',
  TERRAFORM_PROVIDER:
    'https://registry.terraform.io/providers/interdotlink/interlink/latest/docs',
  EVENTS: 'https://inter.link/events',
  CHANGELOG: 'https://inter.link/knowledgebase/release-notes/',
} as const

export const RESOURCES_LINKS = {
  KNOWLEDGE_BASE_DDOS_PROTECTION:
    'https://inter.link/knowledgebase/ddos-protection',
  START_TRIAL: 'https://inter.link/start-a-trial',
  SUSTAINABILITY: 'https://inter.link/sustainability',
  SUPPLIER_CODE_OF_CONDUCT:
    'https://inter.link/hubfs/Download%20Files/Inter.link_Supplier_Code_of_Conduct_DE_EN_15052024.pdf',
  WHATSAPP: 'https://wa.me/4915792522424',
} as const

export const KNOWLEDGE_BASE_LINKS = {
  IP_TRANSIT: 'https://inter.link/knowledgebase/ip-transit',
  IP_ACCESS: 'https://inter.link/knowledgebase/ip-access',
  FLEX_ETHERNET: 'https://inter.link/knowledgebase/flex-ethernet',
  DDOS_PROTECTION: 'https://inter.link/knowledgebase/ddos-protection',
  FLEX_TUNNEL: 'https://inter.link/knowledgebase/knowledgebase-flextunnel/',
  FLOWSPEC: 'https://inter.link/knowledgebase/flowspec/',
  PORTS: 'https://inter.link/knowledgebase/ports',
} as const

export const STATUS_LINKS = {
  STATUS_PAGE: 'https://status.inter.link/',
  STATUS_EVENTS: 'https://status.inter.link/events',
} as const

export const ITEMS_COUNT_TO_SHOW = 24
export const EXTENSION_ITEMS_COUNT_TO_SHOW = 6
export const PLANNED_ITEMS_COUNT_TO_SHOW = 6

export const USAStates = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
]
